module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Intro"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITY OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONES")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("There is a large bay in the southern part of what is now called Florida. The native Calusa people called the bay “Tampa,” meaning “Sticks of Fire,” or “Place of Lighted Sticks.” This was probably because the area was known to have thousands of lightning strikes every year.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Spanish conquerors arrived in the area in the sixteenth century. When they came, there were several different groups of indigenous people already living there. The Tocobaga were settled in the spot where the Hillsborough River meets the Tampa Bay. Archeologists think they lived there for ten thousand years.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Tocobaga are interesting to ghost hunters because when they lived around the bay, they created huge shell mounds. The Tocobaga had little agriculture. They ate mostly oysters and shellfish. When they were done eating, they would pile up the shells. When the mounds were big enough, they used them for temples, homes, and burial sites. The bones of the deceased were buried all around Tampa Bay in these mounds. One mound, more than fifty feet high and two city blocks long, stood where downtown Tampa’s Lykes Gaslight Park is now.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There are no more Tocobaga left. But in the early 1700’s, the Creek settled in the area. We now know them as the Seminoles. They respected the Tocobaga mounds and left them undisturbed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the early 1800’s, the first European American settlers arrived, looking to build homes. They saw the shell mounds and at first, went around them, but the early roads in the area were very muddy. They decided that all those shells would make harder surfaces for horses, mules, oxen, and carts. The mounds were torn down, even the ones that had bones inside, and used to make new roads. Those shell streets were later covered with cobblestones, and then in time, paved over.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Drive down a street in Tampa and you might be driving on top of ancient bones. Can you hear the crunching? With all those bones, come wandering spirits. Can you see them standing near the side of the road?")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The ghosts of Tampa, the Place of Lighted Sticks, tell stories about thousands of years of settlement. Whether they are the spirits of Tocobaga, the Spanish, the Seminoles, the European settlers—they all have something to say.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Let’s listen . . . if you dare.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P12.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7537d72c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 75
// module chunks = 0